import { Routes } from '@angular/router';

export const betaRoutes: Routes = [
  {
    path: 'beta',
    children: [],
  },
];
